import { Event } from "../Event";
import { RolePermissions } from "../../core/enums/RolePermissions";

export class RoleEvents extends Event {
    public onLoad = async () => {
        if (this.userContextProps?.user_fk_role_id !== RolePermissions.MASTER && this.values?.role_id === RolePermissions.MASTER) {
            this.history.route.replace('/dashboard/registrations/roles')
        }
    }
}
